import { InfoCircleOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd'
import React from 'react'
import styled from 'styled-components/macro'

/**
 * Label + info icon tip used across Crow’s Nest headers and table columns.
 */
const CrowsNestTipLabel = ({ label, tip, iconOnly = false, ...rest }) => {
  if (!tip) {
    return iconOnly ? null : <span {...rest}>{label}</span>
  }

  return (
    <Wrap {...rest}>
      {iconOnly ? null : <span>{label}</span>}
      <Tooltip title={tip}>
        <InfoIcon aria-label={typeof tip === 'string' ? tip : 'More info'} />
      </Tooltip>
    </Wrap>
  )
}

const Wrap = styled.span`
  align-items: center;
  display: inline-flex;
  gap: 6px;
`

const InfoIcon = styled(InfoCircleOutlined)`
  color: ${({ theme }) => theme.colours.oliveGrey || '#888'};
  font-size: 13px;
`

export default CrowsNestTipLabel
